<h2 mat-dialog-title>
  <i class="fa fa-list" aria-hidden="true"></i>&nbsp;Future Bids
</h2>
<mat-dialog-content>
  @if (dataSource?.data?.length) {
    <tc-future-bids-list
      [dataSource]="dataSource"
      [displayColumns]="displayColumns"
      [columnNames]="columnNames"
      [showPaginator]="false"
      [showColumnSettings]="false"
      (listChange)="onListChange()">
    </tc-future-bids-list>
  } @else {
    <div class="text-center text-muted" style="padding: 16px">No future bids</div>
  }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">CLOSE</button>
</mat-dialog-actions>